import type { InviteByEmailData, ShareAuthCheckData, ShareLinkResponse } from '../types';

export interface ShareService {
    getShareId(data: ShareAuthCheckData): Promise<ShareLinkResponse>;
    inviteByEmail(data: InviteByEmailData): Promise<void>;
    createPDAShareId(data: {file_group_id: string}): Promise<{share_id: string}>
    sendPDAShareByEmail(data: {share_id: string, receptor: string[]}): Promise<boolean>
}

export const ShareService = Symbol('ShareService');
